module.exports = __webpack_public_path__ + "d202b0f450351bebd94b9e33ee00ae5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/news/010_Young_Henrys-MCA_Cafe_Terrace_869x278.jpg
// module id = 866
// module chunks = 0